module.exports = __webpack_public_path__ + "static/media/pw-bg.e25f6eab.jpg";